import { render, staticRenderFns } from "./CreationForm.vue?vue&type=template&id=caa3ec4e&scoped=true&"
import script from "./CreationForm.vue?vue&type=script&lang=js&"
export * from "./CreationForm.vue?vue&type=script&lang=js&"
import style0 from "./CreationForm.vue?vue&type=style&index=0&id=caa3ec4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa3ec4e",
  null
  
)

export default component.exports